import React, {FunctionComponent, useEffect, useMemo, useRef, useState} from "react";
import * as ReactRedux from "react-redux";
import {
    addedDidYouMeanToSearchBox,
    addedToSearchBox,
    setActiveActionSearchBox,
    setActiveDidYouMean,
    setActiveFilterSearchBox,
    setActiveINET,
    setActiveSalesforce,
    setSearchActionClearFilter,
    toggleAutosuggestion
} from "../../actions/searchBoxAction";
import {
    globalSearchBox,
    globalSearchBoxBusiness,
    globalSearchBoxPro,
    globalStandaloneSearchBoxBusiness,
    globalStandaloneSearchBoxPro,
    redirectTrigger
} from "../../controllers/seachBoxControllers";
import {getValueParamsIsShop, inetDownload, isUrlShop, sendDataAnalytic, useDebounce} from "../../utils/utils";
import "./GlobalSearchBox.scss";
import $ from "jquery";
import {generalTabQuerySummary, resultListAutoSuggestions} from "../../controllers/resultListControllers";
import {productPill, supportPill} from "../../controllers/tabControllers";
import {breadcrumbs, facetCommonCategoryfilter} from '../../controllers/facetControllers';
declare global {
    interface Window {
        dataLayer?: any;
    }
}

let GlobalSearchBoxV2: FunctionComponent<any> = (props) => {
    const {controller} = props;
    const [state, setState] = useState(controller.state);
    const dispatch = ReactRedux.useDispatch();
    const [stateDidYouMean, setStateDidYouMean] = useState(props.didYouMeanController.state);
    const url_string = decodeURI(window.location.href);
    const url = new URL(url_string);
    let searchText: any = url.searchParams.get("productName") ? url.searchParams.get("productName") + " " + url.searchParams.get("q") : url.searchParams.get("q");
    const [currentValue, setCurrentValue] = useState(searchText ? searchText : '');
    const [reloadPage, setReloadPage] = useState(true);
    const debouncedSearchTerm = useDebounce(currentValue);
    const [isDidYouMean, setIsDidYouMean] = useState(false);
    const [isDesktopView, setIsDesktopView] = useState(true);
    const [isEntered, setIsEntered] = useState(false);
    const [stateRedirection, setStateRedirection] = useState(redirectTrigger.state);
    const isActiveDidYouMean = ReactRedux.useSelector((state: any) => state.searchBoxReducer.isActiveDidYouMean);
    const stateDidYouMeanPrev = ReactRedux.useSelector((state: any) => state.searchBoxReducer.stateDidYouMean);
    const [analyticTotalCount, setAnalyticTotalCount] = useState(-1);
    let timeout = useRef(setTimeout(() => {

    }, 0))
    let keyword = useRef(currentValue)
    let host = window.location.host;
    let currentUrl = window.location.href;
    if (currentUrl.includes(host + "/search") || currentUrl.includes(host + "/content/canon/en/search.html")) {
        document.querySelector(".search-container")?.classList.add("search-page");
    } else {
        document.querySelector(".search-container")?.classList.remove("search-page");
    }
    useEffect(() => {
        if (window.innerWidth < 1200) { // $breakpoint-xl-min: 1200px, applied for mobile view
            setIsDesktopView(false);
        } else {
            setIsDesktopView(true);
        }
    }, [window.innerWidth])

    useEffect(() => redirectTrigger.subscribe(() => redirect()), []);
    useEffect(() => {
        if (currentValue) {
            redirect()
        }
    }, [stateRedirection.redirectTo]);

    const redirect = () => {
        setStateRedirection(redirectTrigger.state);
        if (stateRedirection.redirectTo) {
            sendDataAnalytic(currentValue, null, 'forwarded results');
            window.location.href = redirectTrigger.state.redirectTo!;
        }
    };

    useEffect(() => {
        let inputGlobalSearchPro: any = document.querySelectorAll(".tab-pane.active .global-search");
        if (inputGlobalSearchPro[0]) {
            inputGlobalSearchPro[0].value = searchText
        }
    }, [])

    useEffect(() => {
        if (isActiveDidYouMean) {
            setCurrentValue(stateDidYouMeanPrev)
            const activeTabId = document.querySelector(".cmp-header .nav-link.active")?.getAttribute("id");
            switch (activeTabId) {
                case "proTab":
                    globalSearchBoxPro.updateText(stateDidYouMeanPrev)
                    globalSearchBoxPro.state.value = stateDidYouMeanPrev;
                    let inputGlobalSearchPro: any = document.querySelectorAll(".tab-pane.active .global-search");
                    if (inputGlobalSearchPro[0]) {
                        inputGlobalSearchPro[0].value = stateDidYouMeanPrev;
                    }
                    break;
                case "businessTab":
                    globalSearchBoxBusiness.updateText(stateDidYouMeanPrev)
                    globalSearchBoxBusiness.state.value = stateDidYouMeanPrev;
                    let inputGlobalSearchBusiness: any = document.querySelectorAll(".tab-pane.active .global-search");
                    if (inputGlobalSearchBusiness[0]) {
                        inputGlobalSearchBusiness[0].value = stateDidYouMeanPrev;
                    }
                    break;
                default:
                    globalSearchBox.updateText(stateDidYouMeanPrev);
                    globalSearchBox.state.value = stateDidYouMeanPrev;
                    let inputGlobalSearchConsumer: any = document.querySelectorAll(".tab-pane.active .global-search");
                    if (inputGlobalSearchConsumer[0]) {
                        inputGlobalSearchConsumer[0].value = stateDidYouMeanPrev;
                    }
                    break;
            }
            props.dispatch(addedDidYouMeanToSearchBox({stateDidYouMean: ''}));
            props.dispatch(setActiveDidYouMean({isActiveDidYouMean: false}))
        }
    }, [isActiveDidYouMean]);

    useEffect(() => {
        if (reloadPage) {
            return;
        }
        if (!isEntered && debouncedSearchTerm || isActiveDidYouMean) { // Check isEntered to ensure suggestion modal wil be hidden when entering
            updatedStateSuggestion(debouncedSearchTerm);
        }
    }, [debouncedSearchTerm, isActiveDidYouMean]); // Only call effect if debounced search term changes
    useEffect(() => props.didYouMeanController.subscribe(() => setStateDidYouMean(props.didYouMeanController.state)), []);
    useEffect(() => props.didYouMeanController.subscribe(() => {
            if (stateDidYouMean.queryCorrection.correctedQuery !== '' && !isActiveDidYouMean) {
                props.dispatch(addedDidYouMeanToSearchBox({stateDidYouMean: stateDidYouMean.queryCorrection.correctedQuery}));
                setReloadPage(false)
            } else {
                props.dispatch(addedDidYouMeanToSearchBox({stateDidYouMean: ''}));
            }
        }
    ), [stateDidYouMean.queryCorrection.correctedQuery]);

    useMemo(() => {
        if (currentValue.length < 3) {
            props.dispatch(addedToSearchBox({
                ...props, controller: {
                    state: {
                        value: ''
                    }
                }
            }));
            props.dispatch(addedDidYouMeanToSearchBox({stateDidYouMean: ''}));
            props.dispatch(toggleAutosuggestion(false));
            let inputGlobalSearch: any = document.querySelectorAll(".tab-pane.active .global-search");
            if (inputGlobalSearch[0]?.value) {
                keyword.current = inputGlobalSearch[0]?.value;
            }
        }
    }, [currentValue]);

    useEffect(() => {
        controller.subscribe(() => setState(controller.state));
        // Check if the current URL has search query to update search value in controller
        const url_string = decodeURI(window.location.href);
        const url = new URL(url_string);
        if (url.searchParams.get("q")) {
            let searchText: any = url.searchParams.get("q");
            if (url.searchParams.get("productName")) {
                // Check if user searches from FAQ search box
                searchText = url.searchParams.get("productName") + " " + searchText;
                localStorage.setItem("pageUrl", window.location.origin + window.location.pathname + "?productName=" + url.searchParams.get("productName") + "&q=" + url.searchParams.get("q") + "&r=" + isUrlShop.SHOP);
                let newurl = window.location.origin + window.location.pathname + "?productName=" + url.searchParams.get("productName") + "&q=" + url.searchParams.get("q") + "&r=" + isUrlShop.SHOP;
                window.history.pushState({path: newurl}, "", newurl);
            }
        }
    }, [controller]);

    /** Check if there is a redirection footer page when hitting enter in search box
     * If not, redirect to the search result page
     */
    function firstCheckRedirection() {
        setIsEntered(true);
        // Close auto-suggestion when hitting enter
        props.dispatch(toggleAutosuggestion(false));
        if (!reloadPage && currentValue) {
            setTimeout(() => { // wait for checking redirectTrigger.state before jumping on checkRedirectPage
                checkRedirectPage(true);
            }, 500);
        } else {
            checkRedirectPage(false);
        }

        // this section is for no result XF - AEM
        const regex = new RegExp('keyword|<span class=\"word-replaced\">.*<\\/span>', "m");
        const renderResult = (value = null) => {
            let url_string = window.location.href;
            let url = new URL(url_string);
            let queryKeyword = url.searchParams.get("q");
            const $coveoNoResultXF = $("#coveo-no-result-container .rte-cmp");
            let coveoNoResult = $coveoNoResultXF.html();
            if (queryKeyword && coveoNoResult) {
                $coveoNoResultXF.find(".word-replaced").text(currentValue);
            }
        };

        renderResult();
        $(".global-search").keypress(function (e) {
            var key = e.which;
            setTimeout(() => {
                if (key === 13) {
                    // @ts-ignore
                    renderResult($(".global-search").val());
                }
            }, 1000)

        });

    }

    useEffect(() => {
        async function addReduxGlobal() {
            let inputGlobalSearch: any = document.querySelectorAll(".tab-pane.active .global-search");
            const activeTabId = document.querySelector(".cmp-header .nav-link.active")?.getAttribute("id");
            switch (activeTabId) {
                case "proTab":
                    if (inputGlobalSearch[0].value === globalStandaloneSearchBoxPro.state.value) {
                        keyword.current = globalStandaloneSearchBoxPro.state.value;
                        await props.dispatch(addedToSearchBox({controller: globalStandaloneSearchBoxPro}));
                    }
                    break;
                case "businessTab":
                    if (inputGlobalSearch[0].value === globalStandaloneSearchBoxBusiness.state.value) {
                        keyword.current = globalStandaloneSearchBoxBusiness.state.value;
                        await props.dispatch(addedToSearchBox({controller: globalStandaloneSearchBoxBusiness}));

                    }
                    break;
                default:
                    if (inputGlobalSearch[0].value === props.controller.state.value) {
                        keyword.current = props.controller.state.value;
                        await props.dispatch(addedToSearchBox({...props}));

                    }
                    break;
            }

        }

        if (props.isActiveFilterSearchBox) {
            addReduxGlobal();
        }
    }, [globalSearchBox.state, globalSearchBoxPro.state, globalSearchBoxBusiness.state, props.isActiveFilterSearchBox])

    useEffect(() => {
        generalTabQuerySummary.subscribe(() => {
            if (reloadPage && analyticTotalCount !== generalTabQuerySummary.state.total) {
                setAnalyticTotalCount(generalTabQuerySummary.state.total);
            }
        });
    }, []);

    useEffect(() => {
        const url_string = decodeURI(window.location.href);
        const url = new URL(url_string);
        const value = url.searchParams.get("q") ? url.searchParams.get("q") : '';
        if (reloadPage && analyticTotalCount && analyticTotalCount == generalTabQuerySummary.state.total) {
            sendDataAnalytic(value, analyticTotalCount, 'search results');
        }
    }, [analyticTotalCount]);

    useEffect(() => {
        if (isActiveDidYouMean) {
            setCurrentValue(stateDidYouMeanPrev)
            const activeTabId = document.querySelector(".cmp-header .nav-link.active")?.getAttribute("id");
            switch (activeTabId) {
                case "proTab":
                    globalSearchBoxPro.updateText(stateDidYouMeanPrev)
                    globalSearchBoxPro.state.value = stateDidYouMeanPrev;
                    let inputGlobalSearchPro: any = document.querySelectorAll(".tab-pane.active .global-search");
                    if (inputGlobalSearchPro[0]) {
                        inputGlobalSearchPro[0].value = stateDidYouMeanPrev;
                    }
                    break;
                case "businessTab":
                    globalSearchBoxBusiness.updateText(stateDidYouMeanPrev)
                    globalSearchBoxBusiness.state.value = stateDidYouMeanPrev;
                    let inputGlobalSearchBusiness: any = document.querySelectorAll(".tab-pane.active .global-search");
                    if (inputGlobalSearchBusiness[0]) {
                        inputGlobalSearchBusiness[0].value = stateDidYouMeanPrev;
                    }
                    break;
                default:
                    globalSearchBox.updateText(stateDidYouMeanPrev);
                    globalSearchBox.state.value = stateDidYouMeanPrev;
                    let inputGlobalSearchConsumer: any = document.querySelectorAll(".tab-pane.active .global-search");
                    if (inputGlobalSearchConsumer[0]) {
                        inputGlobalSearchConsumer[0].value = stateDidYouMeanPrev;
                    }
                    break;
            }
            props.dispatch(addedDidYouMeanToSearchBox({stateDidYouMean: ''}));
            props.dispatch(setActiveDidYouMean({isActiveDidYouMean: false}))
        }
    }, [isActiveDidYouMean]);


    useEffect(() => {
        if (resultListAutoSuggestions.state.results.length == 0 && state.suggestions[0]?.rawValue) {
            props.suggestionsController.globalTopResultsByFirstSuggestion.updateText(state.suggestions[0].rawValue);
            props.suggestionsController.globalTopResultsByFirstSuggestion.submit();
        }
        return () => {
            clearTimeout(timeout.current);
            timeout.current = setTimeout(() => {
                if (!reloadPage)
                    props.dispatch(toggleAutosuggestion(true));
            }, 0);
        };
    }, [resultListAutoSuggestions.state.results]);

    function updatedStateSuggestion(e: any) {
        setState({
            ...state,
            value: e,
        });
        let isToggle = false;
        if (e.length > 2) {
            props.controller.updateText(e);
            isToggle = true;
            if (isToggle) {
                if (reloadPage) {
                    props.dispatch(toggleAutosuggestion(false));
                }

                /** Don't make API calls for Top Results and Resources when:
                 * 1. users hit enter
                 * 2. in mobileView
                 * 3. reload page
                 * 4. exist didYouMean value (the calls will be make in useEffect of didYouMean state)
                 */
                if (!isEntered && !reloadPage) {
                    if (isDesktopView) {
                        props.suggestionsController.globalSearchBoxTopResultsAutoSuggestions.selectSuggestion(e);
                        //@ts-ignore
                        window.changeKeywordTopResultsAutoSuggestionsAnalytics = true;
                        //@ts-ignore
                        window.changeKeywordTopResultsAutoSuggestionsSearch = true;
                    }
                    props.suggestionsController.globalSearchBoxResourceAutoSuggestions.selectSuggestion(e);
                    //@ts-ignore
                    window.changeKeywordResourceAutoSuggestionsAnalytics = true;
                    //@ts-ignore
                    window.changeKeywordResourceAutoSuggestionsSearch = true;
                    props.dispatch(toggleAutosuggestion(true));
                }
            }
            setTimeout(async function () {
                if (!isDesktopView) {
                    props.dispatch(toggleAutosuggestion(true));
                }
                if (!reloadPage)
                    // await props.dispatch(addedToSearchBox({ ...props }));
                    await props.dispatch(setActiveFilterSearchBox({value: true}))
            }, 1000);
        } else {
            props.dispatch(addedToSearchBox({
                ...props, controller: {
                    state: {
                        value: ''
                    }
                }
            }));
            props.dispatch(toggleAutosuggestion(false));
        }
    }

    function updatedStateEmptySuggestion() {
        setState({
            ...state,
            value: "",
        });
        let inputGlobalSearchBusiness: any = document.querySelectorAll(".tab-pane.active .global-search");
        if (inputGlobalSearchBusiness[0]) {
            inputGlobalSearchBusiness[0].value = '';
        }
        setCurrentValue('');
        props.dispatch(addedDidYouMeanToSearchBox({stateDidYouMean: ''}));
        props.dispatch(addedToSearchBox({...props}));
    }

    // Redirect to configured search result page
    async function submitNextResultPage() {
        const searchPageUrl = document.getElementById("hiddenSearchPageUrlDiv")?.getAttribute("searchPageUrl");
        let redirectTo: any = "";
        let valueParamsIsShop: string = await getValueParamsIsShop();
        let inputGlobalSearchPro: any = document.querySelectorAll(".tab-pane.active .global-search");
        if (inetDownload.some(item => currentValue.toLowerCase().indexOf(item) > -1)) {
            valueParamsIsShop = "support";
        }
        if (currentValue !== "") {
            redirectTo = searchPageUrl ? searchPageUrl + "?q=" + encodeURIComponent(inputGlobalSearchPro[0]?.value) + "&r=" + valueParamsIsShop : "?q=" + encodeURIComponent(inputGlobalSearchPro[0]?.value) + "&r=" + valueParamsIsShop;
        } else {
            redirectTo = searchPageUrl ? searchPageUrl + "?r=" + valueParamsIsShop : "?r=" + valueParamsIsShop;
        }
        localStorage.setItem("pageUrl", redirectTo);
        // Close auto-suggestion when entering and redirect to search result page
        props.dispatch(toggleAutosuggestion(false));
        setTimeout(() => { // wait for checking redirectTrigger.state before redirect to search result page
            window.location = redirectTo;
        }, 500);
    }

    // Update the URL with encoded input value (eg. in case there is a white space between search keyword)
    async function insertParam(key: any, value: any) {
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);
        if (window.history.pushState) {
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?q=" + value + "&r=" + url.searchParams.get('r');
            window.history.pushState({path: newurl}, "", newurl);
        }
    }

    // Update the current URL with the input value using history.pushState
    // Continue the search action if user is in search results page.
    // Otherwise, it'll redirect to the configured search results page
    async function checkRedirectPage(reload: boolean = false) {
        setIsEntered(false);
        // Reset header-mode in localStorage to the current active tab when searching by a keyword
        const activeTabId = document.querySelector(".cmp-header .nav-link.active")?.getAttribute("id");
        const currentHeaderMode = activeTabId?.split("Tab")[0];
        if (currentHeaderMode) {
            localStorage.setItem("header-mode", currentHeaderMode);
        }
        dispatch(setActiveActionSearchBox(true));
        // Close auto-suggestion when hitting enter
        props.dispatch(toggleAutosuggestion(false));
        const pageUrl = localStorage.getItem("pageUrl");
        const deCodeUri = decodeURI(window.location.href);
        let valueParamsIsShop: string | null = url.searchParams.get('r');
        if (deCodeUri.includes(`${pageUrl}`) && !inetDownload.some(item => currentValue.toLowerCase().indexOf(item) > -1)) {
            if (currentValue === "") {
                localStorage.setItem("pageUrl", window.location.host + window.location.pathname + "?r=" + valueParamsIsShop);
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?r=" + valueParamsIsShop;
                window.history.pushState({path: newurl}, "", newurl);
            } else {
                localStorage.setItem("pageUrl", window.location.host + window.location.pathname + "?q=" + currentValue + "&r=" + valueParamsIsShop);
                insertParam("q", currentValue);
            }
            // controller.updateText(currentValue);
            if (reload) {
                breadcrumbs.deselectAll();
                dispatch(setActiveSalesforce({value: false}));
                dispatch(setActiveINET({value: false}));
                let pillActive = {value: "Support", state: "selected"};
                if (valueParamsIsShop === "product") {
                    pillActive.value = "Product";
                }
                const activeTabId = document.querySelector(".cmp-header .nav-link.active")?.getAttribute("id");
                switch (activeTabId) {
                    case "proTab":
                        globalSearchBoxPro.selectSuggestion(currentValue);
                        break;
                    case "businessTab":
                        globalSearchBoxBusiness.selectSuggestion(currentValue);
                        break;
                    default:
                        globalSearchBox.selectSuggestion(currentValue);
                        break;
                }
                // @ts-ignore
                facetCommonCategoryfilter.toggleSingleSelect(pillActive);
                controller.selectSuggestion(currentValue);
                //@ts-ignore
                window.searchBoxEntered = true;
                //@ts-ignore
                window.refreshPage = true;
            }
            props.dispatch(setSearchActionClearFilter(true));
            if (!reloadPage) {
                setTimeout(() => {
                    sendDataAnalytic(currentValue, generalTabQuerySummary.state.total, 'search results');
                }, 1500);
            }
        } else {
            submitNextResultPage();
        }
    }

    return (
        <div className="search-button-form form-inline">
            <label className="visually-hidden">Search input</label>
            <input
                maxLength={100}
                // value={currentValue}
                className="form-control global-search mr-sm-2"
                placeholder="Search products, support and more"
                onFocus={() => {
                    setReloadPage(false)
                }}
                onChange={(e) => {
                    if (reloadPage) {
                        setCurrentValue(e.target.value)
                        setReloadPage(false)
                    }
                    setCurrentValue(e.target.value)
                }
                }
                onKeyDown={(e) => e.key === "Enter" && firstCheckRedirection()}
            />
            <button className="btn search-btn headerSearchIcon" aria-label="Search">
                <div className="icon icon-search" onClick={firstCheckRedirection}></div>
            </button>
            {currentValue.length > 0 && (
                <button
                    className="btn close-image-container"
                    onClick={updatedStateEmptySuggestion}
                >
                    <div className="close-image"></div>
                </button>
            )}
            {document.querySelectorAll('.cmp-header .search-button-form')?.forEach(el => el.parentElement?.classList.add('search-button-form-wrapper'))}
        </div>
    );
};

GlobalSearchBoxV2 = ReactRedux.connect((state: any, ownProps) => {
    return {
        isActiveFilterSearchBox: state.searchBoxReducer.isActiveFilterSearchBox,
        pillActived: state.searchBoxReducer.pillActived,
        ...ownProps,
    };
})(GlobalSearchBoxV2);

export default GlobalSearchBoxV2;
